"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _input = _interopRequireDefault(require("../../../../core/input"));
var _inputOnBlur = _interopRequireDefault(require("../../../../core/input-on-blur"));
var _edit = _interopRequireDefault(require("../../../../../icons/edit"));
var _editEntryForm = _interopRequireDefault(require("./edit-entry-form"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // This pops up a modal to display the entry details in a form format
// to make editing easier.
var _ref = /*#__PURE__*/_react.default.createElement(_edit.default, null);
class EditEntry extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isEditingEntry: false
    });
    _defineProperty(this, "_onEditEntry", () => {
      this.setState({
        isEditingEntry: true
      });
    });
    _defineProperty(this, "_onFinish", () => {
      this.setState({
        isEditingEntry: false
      });
    });
  }
  render() {
    const entry = this.props.entry;
    return /*#__PURE__*/_react.default.createElement("span", null, !this.state.isEditingEntry ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._onFinish
      }, "Done"),
      onClose: this._onFinish,
      title: (entry.isOnlineEntry ? 'Edit Online Entry to ' : 'Edit Postal Entry to ') + entry.race.raceName + ' on ' + (0, _occasion.default)(entry.race.competitionDay.dayDate, 'dddd'),
      size: "lg"
    }, /*#__PURE__*/_react.default.createElement(_editEntryForm.default, {
      entry: entry,
      useFreeCode: this.props.useFreeCode
    })), /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "default",
      onClick: this._onEditEntry,
      style: {
        paddingRight: '0.1rem',
        paddingLeft: '0.1rem'
      }
    }, _ref));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(EditEntry, "partialQueries", {
  Entry: _mergeBqlQueries({
    id: true,
    isOnlineEntry: true,
    race: {
      raceName: true,
      competitionDay: {
        dayDate: true
      }
    }
  }, _editEntryForm.default.partialQueries.Entry)
});
var _default = exports.default = EditEntry;